import React, { FunctionComponent, MouseEvent, useState } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

type BasicDialogProps = {
    readonly isSelected: boolean;
    readonly name: string;
    readonly onItemClick: (e: MouseEvent) => void;
};

const classNames = bemClassNames("basic-dialog-item-component");

export const BasicDialogItem: FunctionComponent<BasicDialogProps> = ({ isSelected, name, onItemClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);

    const onMouseOver = () => {
        if (!isMouseOver)
            setIsMouseOver(true);
    };

    const onMouseLeave = () => {
        if (isMouseOver)
            setIsMouseOver(false);
    };

    return <p className={classNames({ "is-mouse-over": isMouseOver, "selected": isSelected })} onClick={onItemClick} {...{ onMouseOver, onMouseLeave }}>{name}</p>;
};
